var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldarrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6257 50.6791L45.1758 39.1291C45.5892 38.7165 45.9172 38.2264 46.141 37.687C46.3648 37.1475 46.48 36.5692 46.48 35.9851C46.48 35.4011 46.3648 34.8227 46.141 34.2833C45.9172 33.7438 45.5892 33.2537 45.1758 32.8412L33.6257 21.2911C30.8163 18.5262 26 20.4884 26 24.4573V47.5129C26 51.5264 30.8163 53.4886 33.6257 50.6791Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldarrowRight);
export default __webpack_public_path__ + "static/media/boldarrowRight.9edfc3ff071afa2bec0fae09779da669.svg";
export { ForwardRef as ReactComponent };